'use client';

import Intercom, { shutdown, update } from '@intercom/messenger-js-sdk';
import { useEffect, useRef } from 'react';
import useUser from '@/app/hooks/useUser';

export default function IntercomProvider() {
  const { user, isLoading } = useUser();
  const hasBooted = useRef(false);
  useEffect(() => {
    try {
      if (isLoading || !process.env.NEXT_PUBLIC_INTERCOM_ID) return;

      if (!hasBooted.current) {
        if (user) {
          Intercom({
            app_id: process.env.NEXT_PUBLIC_INTERCOM_ID,
            user_id: user.uuid,
            name: user.name ?? '',
            email: user.email ?? '',
            intercom_user_jwt: user.token,
            custom_attributes: {
              app: 'expenses',
              platform: 'web',
            },
          });
        } else {
          // anonymous user
          Intercom({
            app_id: process.env.NEXT_PUBLIC_INTERCOM_ID,
            custom_attributes: { app: 'expenses', platform: 'web' },
          });
        }
        hasBooted.current = true;
      } else if (user) {
        // already booted – just update
        update({
          user_id: user.uuid,
          name: user.name ?? '',
          email: user.email ?? '',
          intercom_user_jwt: user.token,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }, [user, isLoading]);

  useEffect(() => {
    return () => shutdown(); // clean-up on unmount only
  }, []);

  return null; // This component does not render anything
}
